(function () {

  // Inject the highlight styles once
  var existing = document.getElementById('partra-ymm-highlight-style');
  if (existing) existing.remove();
  var style = document.createElement('style');
  style.id = 'partra-ymm-highlight-style';
  style.textContent = [
    '.partra-ymm-highlight {',
    '  outline: 3px solid #dc0000 !important;',
    '  outline-offset: -3px !important;',
    '}',
    '.partra-ymm-highlight #fw-plate::placeholder,',
    '.partra-ymm-highlight #fw-plate-vertical::placeholder {',
    '  color: #dc0000 !important;',
    '}',
    '.partra-ymm-highlight #fw-plate,',
    '.partra-ymm-highlight #fw-plate-vertical {',
    '  color: #dc0000 !important;',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  function applyHighlight() {
    var el = document.querySelector('.fw-container') || document.querySelector('.fw');
    if (!el) return;
    el.classList.add('partra-ymm-highlight');
    setTimeout(function () {
      el.classList.remove('partra-ymm-highlight');
    }, 3000);
  }

  function getCurrentMode() {
    var fw = document.querySelector('.fw');
    if (!fw) return 'registration';
    return fw.getAttribute('data-active') || 'registration';
  }

  function showError() {
    var mode = getCurrentMode();
    if (mode === 'model') {
      if (typeof window.partraShowModelError === 'function') {
        window.partraShowModelError();
      }
    } else {
      if (typeof window.partraShowPlateError === 'function') {
        window.partraShowPlateError();
      }
    }
  }

  function callErrorWhenReady(maxWaitMs) {
    var fnNeeded = getCurrentMode() === 'model' ? 'partraShowModelError' : 'partraShowPlateError';
    if (typeof window[fnNeeded] === 'function') {
      showError();
      return;
    }
    maxWaitMs = maxWaitMs || 2000;
    var elapsed = 0;
    var interval = 80;
    var timer = setInterval(function () {
      elapsed += interval;
      if (typeof window[fnNeeded] === 'function') {
        clearInterval(timer);
        showError();
      } else if (elapsed >= maxWaitMs) {
        clearInterval(timer);
      }
    }, interval);
  }

  window.partraHighlightYMM = function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    applyHighlight();
    callErrorWhenReady(2000);
  };

  // Delegated click handler (fallback for any label not using inline onclick)
 document.addEventListener('click', function (e) {
  var label = e.target.closest('.fitment-label-wrapper');
  if (!label) return;
  var v = null;
  try { v = localStorage.getItem('vehicle_fitment_active'); } catch (err) {}
  if (!v) {
    e.preventDefault();
    e.stopPropagation();
    var card = label.closest('[data-product-handle]');
   // Fitment collections — keep in sync with the Liquid gates (claude_theme.md §2).
   // Filters + wipers, then the car-bulbs sub-collections.
   var FITMENT_COLLECTIONS = (window.PARTRA_FITMENT_COLLECTIONS || []).map(function (h) { return String(h).trim(); }).filter(Boolean).map(function (h) { return '/collections/' + h.replace(/^\/collections\//, ''); });
var onFitmentCollection = FITMENT_COLLECTIONS.some(function(c) { return window.location.pathname.indexOf(c) !== -1; });
if (onFitmentCollection) {
  window.partraHighlightYMM();
} else {
  var pt = card ? card.getAttribute('data-product-type') : '';
  var handle = pt ? pt.toLowerCase().trim().replace(/\s+/g, '-') : '';
  if (handle) {
    window.location.href = '/collections/' + handle + '?partra_highlight=1';
  } else {
    // No product-type signal — highlight in place rather than defaulting to any one collection
    window.partraHighlightYMM();
  }
}
  }
}, true);
 function reapplyFitmentLabels() {
    var CACHE_DURATION = 30 * 60 * 1000;
    var cards = document.querySelectorAll('[data-fitment-label]');
    if (!cards.length) return;

    var fitmentActive = localStorage.getItem('vehicle_fitment_active');
    if (!fitmentActive) {
      cards.forEach(function(wrapper) { setLabel(wrapper, 'check'); });
      return;
    }

    var resolvedHandles = null;
    try {
      var raw = localStorage.getItem('vehicle_fitment_all_handles');
      if (raw) {
        var parsed = JSON.parse(raw);
        var age = Date.now() - (parsed.timestamp || 0);
        if (age < CACHE_DURATION && Array.isArray(parsed.handles) && parsed.handles.length > 0) {
          resolvedHandles = parsed.handles;
        }
      }
    } catch(e) {}

    if (!resolvedHandles) {
      cards.forEach(function(wrapper) { setLabel(wrapper, 'check'); });
      return;
    }

    cards.forEach(function(wrapper) {
      var parent = wrapper.closest('[data-product-handle]');
      var handle = parent ? parent.getAttribute('data-product-handle') : null;
      if (!handle) return;
      setLabel(wrapper, resolvedHandles.indexOf(handle) !== -1 ? 'fits' : 'no-fit');
    });
  }

  function setLabel(wrapper, state) {
    var span = wrapper.querySelector('.fitment-label');
    if (!span) return;
    var icons = {
      fits:    document.getElementById('fitment-icon-fits')    ? document.getElementById('fitment-icon-fits').innerHTML    : '',
      'no-fit': document.getElementById('fitment-icon-no-fit') ? document.getElementById('fitment-icon-no-fit').innerHTML  : '',
      check:   document.getElementById('fitment-icon-check')   ? document.getElementById('fitment-icon-check').innerHTML   : ''
    };
    var configs = {
      fits:     { cls: 'fitment-label--fits',    icon: icons['fits'],    text: 'Fits your vehicle' },
      'no-fit': { cls: 'fitment-label--no-fit',  icon: icons['no-fit'],  text: 'Not Compatible' },
      check:    { cls: 'fitment-label--check',   icon: icons['check'],   text: 'Check compatibility' }
    };
    var cfg = configs[state];
    if (!cfg) return;
    span.classList.remove('fitment-label--loading', 'fitment-label--fits', 'fitment-label--no-fit', 'fitment-label--check');
    span.classList.add(cfg.cls);
    span.innerHTML = cfg.icon + '<span style="margin-left:6px;">' + cfg.text + '</span>';
  }

  document.addEventListener('partra:vehicle-saved', reapplyFitmentLabels);

  (function() {
  if (new URLSearchParams(window.location.search).get('partra_highlight') !== '1') return;

  // Clean the query param from the URL without reloading
  if (window.history && window.history.replaceState) {
    var cleaned = window.location.pathname + window.location.search
      .replace(/[?&]partra_highlight=1/, '')
      .replace(/^\&/, '?')
      .replace(/\?$/, '');
    window.history.replaceState(null, '', cleaned || window.location.pathname);
  }

  // Poll until the widget is in the DOM (it may render after JS runs)
  var tries = 0;
  var timer = setInterval(function() {
    tries++;
    var el = document.querySelector('.fw-container') || document.querySelector('.fw');
    if (el) {
      clearInterval(timer);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      applyHighlight();
      callErrorWhenReady(2000);
    } else if (tries > 50) {
      clearInterval(timer);
    }
  }, 100);
})();


})();